import { useEffect, useRef, useState } from "react";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { modelDetailsSchema } from "../../utils/validationSchema/modelValidationSchema";

const useCreateModel = (props = {}) => {
  const { id } = props;
  const { authData, storeId } = useSelector((state) => state.loginSlice);
  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openImageMarking, setOpenImageMarking] = useState(false);
  const [modelDetails, setModelDetails] = useState({
    modelCode: "",
    modelName: "",
    gender: "",
    sType: "",
  });
  const [selectOptions, setSelectOptions] = useState({
    bodyTypeOptions: [],
    genderOptions: [],
  });
  const [imageJson, setImageJson] = useState({
    iBodyTypeId: null,
  });
  const [selectedImage, setSelectedImage] = useState({});
  const [openImage, setOpenImage] = useState(false);
  const [modelImage, setModelImage] = useState(null);
  const [imageTabs, setImageTabs] = useState([]);
  const [apiLoader, setApiLoader] = useState(false);
  const [createitemstatus, setCreateitemstatus] = useState("");
  const [show, setShow] = useState(false);
  const [imageError, setImageError] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [isImageEditing, setIsImageEditing] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [imageLoader, setImageLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [errors, setErrors] = useState(null);
  const [imageDetails, setImageDetails] = useState({
    modelName: "",
    iBodyTypeId: null,
    iGenderId: null,
  });
  const [newCoordinates, setNewCoordinates] = useState({});
  const [selectedModalId, setSelectedModalId] = useState(null);
  const [openCoordinates, setOpenCoordinates] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isPythonCalled, setIsPythonCalled] = useState(false);
  const coordinatesRef = useRef(false);

  const handleEditClick = () => {
    setIsEdit(true);
    coordinatesRef.current = true;
  };

  const fetchFormData = async () => {
    try {
      const response = await apiHandler({
        url: endpoint.GET_FORMDATA,
        method: "GET",
        authToken: authData,
        storeId,
        dispatch,
      });
      if (response.data.status === "success") {
        setSelectOptions({
          ...selectOptions,
          genderOptions: response.data.data.genderDropdown,
          bodyTypeOptions: response.data.data.bodyTypeDropdown,
        });
      }
    } catch (error) {
      console.log("Error fetching form data", error);
    }
  };

  const fetchModelById = async () => {
    try {
      const response = await apiHandler({
        url: `${endpoint.GET_MODEL}/${id}`,
        method: "GET",
        authToken: authData,
        storeId,
        dispatch,
      });
      if (response.data.status === "success") {
        const model = response.data.data.ModelData[0];
        const dateWef = new Date(model.dtWEF);
        const month = (dateWef.getMonth() + 1).toString().padStart(2, "0");
        const day = dateWef.getDate().toString().padStart(2, "0");
        const year = dateWef.getFullYear();
        const formattedDatewef = `${year}-${month}-${day}`;
        const dateWet = new Date(model.dtWEF);
        const monthwet = (dateWet.getMonth() + 1).toString().padStart(2, "0");
        const daywet = dateWef.getDate().toString().padStart(2, "0");
        const yearwet = dateWef.getFullYear();
        const formattedDatewet = `${yearwet}-${monthwet}-${daywet}`;
        setModelDetails({
          ...modelDetails,
          ...model,
          modelCode: model.sCode,
          modelName: model.sName,
          ageBand: model.iAgeBandId,
          gender: model.iGenderId,
          dtWEF: formattedDatewef,
          dtWET: formattedDatewet,
          sType: model.sType,
        });
        // const gender = selectOptions.genderOptions.filter((age) => {
        //   return age.iGenderId === parseInt(model.iGenderId);
        // });
        // const ageBand = selectOptions.ageBandOptions.filter((age) => {
        //   return age.iAgeBandId === parseInt(iAgeBandId);
        // });

        setImageSrc(model.sModelImage);
        const imgtabs = JSON.parse(model.ModelImageJson).map((img) => {
          return {
            ...img,
            imageUrl: img.sURL,
            sTagName: img.sTag,
          };
        });
        setImageTabs(imgtabs);
      }
    } catch (error) {
      console.log("Error fetching product", error);
    }
  };

  function getMessageForValidationError(errors, stringToMatch) {
    for (const error of errors) {
      if (error.path && error.path.length > 1) {
        var acc = {};

        if (error.path[0] === "NomineeList") {
          acc[`${error.path[2]}${error.path[1]}`] = error.message;
        }
        return acc;
      } else if (
        error.path &&
        error.path.length > 0 &&
        error.path[0] === stringToMatch
      ) {
        return error.message;
      }
    }
    return null;
  }

  const handleBlur = (e) => {
    const { name, value } = e.target;

    let validationbody = {
      [name]: value,
    };

    const validationResult = modelDetailsSchema.validate(validationbody, {
      abortEarly: false,
      allowUnknown: true,
    });

    if (validationResult.error) {
      const error = getMessageForValidationError(
        validationResult.error.details,
        name
      );
      // console.log({ [name]: error });
      setErrors({ ...errors, [name]: error });
    } else {
      // Clear the error for this field if validation succeeds
      setErrors({ ...errors, [name]: "" });
    }
  };

  const renderErrorMessage = (fieldName) => {
    if (errors && errors[fieldName]) {
      return errors[fieldName];
    }
    return null;
  };

  useEffect(() => {
    if (id) {
      fetchModelById();
    }
  }, []);

  useEffect(() => {
    fetchFormData();
  }, []);

  const handleImageChange = async (e) => {
    const image = e.target.files[0];

    await getCoordinates(image);
    if (image) {
      // const imageUrl = URL.createObjectURL(image);
      fileInputRef.current = image;
    }
  };

  const handleTabLabelChange = (e, name) => {
    const tabLabel = e.target.value;
    if (name === "iBodyTypeId") {
      const source = selectOptions.bodyTypeOptions.filter((age) => {
        return age.iBodyTypeId === parseInt(tabLabel);
      });
      setImageJson((prevState) => ({
        ...prevState,
        bodyType: source[0],
        iBodyTypeId: tabLabel,
      }));
    } else if (name === "sTone") {
      setImageJson((prevState) => ({
        ...prevState,
        sTone: tabLabel,
        dToneValue: tabLabel === "light" ? 0 : "",
      }));
    } else if (name === "dToneValue") {
      const regex = /^(0(\.\d{0,1})?|1(\.0{0,1})?)$/;
      if (tabLabel === "" || regex.test(tabLabel)) {
        setImageJson((prevState) => ({
          ...prevState,
          dToneValue: tabLabel,
        }));
      }
    }

    //setImageJson((prevState) => ({ ...prevState, [name]: tabLabel }));
  };

  const handleAddImageTab = (e) => {
    if (!isEditing) {
      e.preventDefault();
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      if (imageJson.sURL) {
        let imgJson = { ...imageJson };

        setImageTabs([...imageTabs, imgJson]);
        setImageJson({
          imageUrl: "",
          tabLabel: "",
          image: "",
          iCategoryId: "",
          iBodyTypeId: null,
        });
      }
      setOpenImage(false);
    } else {
      e.preventDefault();

      const updatedImageTabs = [...imageTabs];
      updatedImageTabs[editIndex] = { ...imageJson };

      setOpenImage(false);
      setImageTabs(updatedImageTabs);
      setIsEditing(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setModelDetails({
      ...modelDetails,
      [name]: value,
    });
  };

  const handleDelete = (index) => {
    if (!id) {
      const newImageTabs = imageTabs.filter((_, i) => i !== index);
      setImageTabs(newImageTabs);
    } else {
      const newImageTabs = imageTabs.filter((_, i) => i !== index);

      // const removedImage = imageTabs[index];

      setImageTabs(newImageTabs);
    }
    setConfirmDelete(false);
  };

  const handleEdit = (index) => {
    const imageJson = imageTabs[index];

    setEditIndex(index);
    setIsEditing(true);
    setImageJson(imageJson);
    setOpenImage(true);
  };

  const getCoordinates = async (file) => {
    setImageLoader(true);

    const timeout = new Promise((_, reject) =>
      setTimeout(() => reject(new Error("Request timed out")), 60000)
    );

    const fetchCoordinates = async () => {
      const formData = new FormData();
      formData.append("BodyTypeImage", file);
      const bodyType = selectOptions.bodyTypeOptions.find(
        (body) => body.iBodyTypeId === parseInt(imageJson.iBodyTypeId)
      );
      const images = [
        {
          name: file.name,
          iBodyTypeId: imageJson.iBodyTypeId,
          sName: bodyType?.sName,
        },
      ];

      formData.append("sTone", imageJson.sTone);
      // formData.append("sName", bodyType.sName);

      formData.append("aImagesJson", JSON.stringify(images));

      const response = await apiHandler({
        url: endpoint.GET_CORDINATES,
        method: "POST",
        data: formData,
        authToken: authData,
        storeId,
        dispatch,
      });

      return response;
    };

    try {
      const response = await Promise.race([fetchCoordinates(), timeout]);
      if (response.data.status === "success") {
        setImageJson({
          ...imageJson,
          ...response.data.data[0],
        });
      } else {
        setErrorMessage(response.data.message);
      }
    } catch (error) {
      if (error.message === "Request timed out") {
        setErrorMessage("Please change the image");
        console.error("The request timed out.");
      } else {
        console.error("Error fetching coordinates", error);
      }
    } finally {
      setImageLoader(false);
    }
  };

  const handleModelChange = async (e) => {
    const file = e.target.files[0];

    const imageUrl = URL.createObjectURL(file);
    setModelImage(file);
    setImageSrc(imageUrl);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const createModel = async () => {
    try {
      if (imageTabs.length <= 0) {
        setImageError("Add atleast one image");
        return;
      }
      setApiLoader(true);
      const formData = new FormData();
      formData.append("sName", modelDetails.modelName);
      formData.append("sType", modelDetails.sType);
      // formData.append("sCode", "12434");
      formData.append("iGenderId", parseInt(modelDetails.gender));
      formData.append("ModelImage", modelImage);
      const aImagesJson = imageTabs.map((img) => {
        return {
          sCode: img.sCode,
          sURL: img.sURL,
          iBodyTypeId: img.iBodyTypeId,
          sCoordinates: img.sCoordinates,
          sTagName: img.sTagName,
          sImgBase64: img.sImgBase64,
          sUUID: img.sUUID,
          sTone: img.sTone,
          dToneValue: img.dToneValue,
        };
      });

      formData.append("aImagesJson", JSON.stringify(aImagesJson));

      const response = await apiHandler({
        url: endpoint.CREATE_MODEL,
        method: "POST",
        authToken: authData,
        data: formData,
        storeId,
        dispatch,
      });
      if (response.data.status === "success") {
        setCreateitemstatus(response.data.message);
        setApiLoader(false);
        handleShow();
      } else {
        setCreateitemstatus(response.data.message);
        //setApiError(false);
        handleShow();
      }
    } catch (error) {
      console.log("Error creating a model:", error);
    } finally {
      setApiLoader(false);
    }
  };

  const navigating = () => {
    handleClose();
    navigate("/modelsandbox");
  };

  const handleBack = () => {
    navigate("/modelsandbox");
  };
  // console.log(modelDetails);

  const handleSubmit = () => {
    const data = {
      modelName: modelDetails.modelName,
      gender: parseInt(modelDetails.gender),
      sType: modelDetails.sType,
      modelImage: modelImage || imageSrc,
    };
    const validationResult = modelDetailsSchema.validate(data, {
      abortEarly: false,
    });
    console.log(validationResult);

    if (validationResult.error) {
      let errors = null;
      errors = validationResult.error.details.reduce((acc, error) => {
        acc[error.path[0]] = error.message;
        return acc;
      }, {});
      setErrors(errors);
    } else {
      if (id) {
        updateModel();
      } else {
        createModel();
      }
    }
  };

  useEffect(() => {
    if (modelImage) {
      setErrors((prev) => ({
        ...prev,
        modelImage: "",
      }));
    }
  }, [modelImage]);

  const updateModel = async () => {
    try {
      setApiLoader(true);

      const formData = new FormData();
      formData.append("sName", modelDetails.modelName);
      formData.append("sType", modelDetails.sType);
      formData.append("sCode", modelDetails.modelCode);
      formData.append("iGenderId", parseInt(modelDetails.gender));
      formData.append("ModelImage", modelImage);
      imageTabs.map((img) => {
        formData.append("BodyTypeImage", img.image ? img.image : null);
      });

      const aImagesJson = imageTabs?.map((img) => {
        return {
          sURL: img.sURL,
          sType: img.sCode,
          iBodyTypeId: img.iBodyTypeId,
          sCoordinates: img.sCoordinates,
          sTagName: img.sTagName,
          sImgBase64: img.sImgBase64,
          sUUID: img.sUUID,
          dToneValue: img.dToneValue,
          sTone: img.sTone,
          iGalleryId: img.iGalleryId ? img.iGalleryId : null,
        };
      });

      formData.append("aImagesJson", JSON.stringify(aImagesJson));
      const response = await apiHandler({
        url: `${endpoint.UPDATE_MODEL}/${id}`,
        method: "PUT",
        authToken: authData,
        data: formData,
        storeId,
        dispatch,
      });
      if (response.data.status === "success") {
        setCreateitemstatus(response.data.message);
        setApiLoader(false);
        handleShow();
      } else {
        setCreateitemstatus(response.data.message);
        handleShow();
      }
    } catch (error) {
      console.log("Error updating products", error);
    } finally {
      setApiLoader(false);
    }
  };

  const handleDebugVersion = () => {
    const demoDiv = document.querySelector(".demo");

    if (!demoDiv) {
      console.error("Element with class 'demo' not found in the DOM.");
      return;
    }
    demoDiv.innerHTML = "";

    if (demoDiv.innerHTML) {
      demoDiv.innerHTML = "";
    } else {
      if (
        parseInt(imageDetails.iBodyTypeId) === 1 ||
        imageDetails.iBodyTypeId === 1
      ) {
        const wristCoordinates = imageDetails.sCoordinate.wrist
          ? JSON.parse(imageDetails.sCoordinate.wrist)
          : JSON.parse(imageDetails.sCoordinate);

        if (wristCoordinates) {
          let [leftX, leftY] = wristCoordinates.left;
          leftX = leftX * 300;
          leftY = leftY * 350;

          let [rightX, rightY] = wristCoordinates.right;
          rightX = rightX * 300;
          rightY = rightY * 350;

          let centerX = (leftX + rightX) / 2;
          let centerY = (leftY + rightY) / 2;

          demoDiv.innerHTML = "";

          const createDot = (x, y, color) => {
            let dot = document.createElement("div");
            dot.style.position = "absolute";
            dot.style.backgroundColor = color;
            dot.style.width = "5px";
            dot.style.height = "5px";
            dot.style.top = `${y}px`;
            dot.style.left = `${x}px`;
            dot.style.zIndex = 2;
            dot.style.borderRadius = "50%";
            return dot;
          };

          demoDiv.appendChild(createDot(leftX, leftY, "orange"));
          demoDiv.appendChild(createDot(rightX, rightY, "green"));
          demoDiv.appendChild(createDot(centerX, centerY, "tomato"));
        } else {
          console.log("Finger data not found for the current finger.");
        }
      } else if (parseInt(imageDetails.iBodyTypeId) === 3) {
        if (imageDetails.sCoordinate) {
          const fingerCoordinates = JSON.parse(imageDetails.sCoordinate);
          ["Index", "Middle", "Pinky", "Ring"].forEach((finger, index) => {
            const currentFingerData =
              fingerCoordinates?.[finger] ||
              fingerCoordinates[finger.toLowerCase()];
            if (currentFingerData) {
              let [leftX, leftY] = currentFingerData.left;
              leftX = leftX * 300;
              leftY = leftY * 350;
              let [rightX, rightY] = currentFingerData.right;
              rightX = rightX * 300;
              rightY = rightY * 350;
              let centerX = (leftX + rightX) / 2;
              let centerY = (leftY + rightY) / 2;
              const demoDiv = document.querySelector(`.demo${index}`);

              demoDiv.innerHTML = "";
              const createDot = (x, y, color) => {
                let dot = document.createElement("div");
                dot.style.position = "absolute";
                dot.style.backgroundColor = color;
                dot.style.width = "5px";
                dot.style.height = "5px";
                dot.style.top = `${y}px`;
                dot.style.left = `${x}px`;
                dot.style.zIndex = 2;
                dot.style.borderRadius = "50%";
                return dot;
              };
              demoDiv.appendChild(createDot(leftX, leftY, "orange"));
              demoDiv.appendChild(createDot(rightX, rightY, "green"));
              demoDiv.appendChild(createDot(centerX, centerY, "tomato"));
            } else {
              console.error("Finger data not found for the current finger.");
            }
          });
        }
      } else if (parseInt(imageDetails.iBodyTypeId) === 2) {
        // const neckCoordinates = JSON.parse(imageDetails.sCoordinate)
        //   .neck_coordinates.neck_wide;

        const earCoordinates = JSON.parse(
          imageDetails.sCoordinate
        )?.ear_coordinates;

        demoDiv.innerHTML = "";

        const createDot = (x, y, color) => {
          let dot = document.createElement("div");
          dot.style.position = "absolute";
          dot.style.backgroundColor = color;
          dot.style.width = "5px";
          dot.style.height = "5px";
          dot.style.borderRadius = "50%";
          dot.style.top = `${y}px`;
          dot.style.left = `${x}px`;
          dot.style.zIndex = 2;
          return dot;
        };

        // if (neckCoordinates) {
        //   let [leftX, leftY] = neckCoordinates.left_point;
        //   leftX = leftX * 300;
        //   leftY = leftY * 350;

        //   let [rightX, rightY] = neckCoordinates.right_point;
        //   rightX = rightX * 300;
        //   rightY = rightY * 350;

        //   let centerX = (leftX + rightX) / 2;
        //   let centerY = (leftY + rightY) / 2;

        //   demoDiv.appendChild(createDot(leftX, leftY, "orange"));
        //   demoDiv.appendChild(createDot(rightX, rightY, "green"));
        //   demoDiv.appendChild(createDot(centerX, centerY, "tomato"));
        // }

        if (earCoordinates) {
          if (earCoordinates[0]) {
            let [leftEarX, leftEarY] = earCoordinates[0];
            leftEarX = leftEarX * 300;
            leftEarY = leftEarY * 350;

            demoDiv.appendChild(createDot(leftEarX, leftEarY, "black"));
          }

          if (earCoordinates[1]) {
            let [rightEarX, rightEarY] = earCoordinates[1];
            rightEarX = rightEarX * 300;
            rightEarY = rightEarY * 350;

            demoDiv.appendChild(createDot(rightEarX, rightEarY, "black"));
          }
        }
      } else if (parseInt(imageDetails.iBodyTypeId) === 4) {
        const neckCoordinates = JSON.parse(imageDetails?.sCoordinate)
          ?.neck_coordinates?.neck_wide
          ? JSON.parse(imageDetails?.sCoordinate)?.neck_coordinates?.neck_wide
          : JSON.parse(imageDetails?.sCoordinate)?.neck_mask_wide;

        const earCoordinates = JSON.parse(
          imageDetails.sCoordinate
        )?.ear_coordinates;

        demoDiv.innerHTML = "";

        const createDot = (x, y, color) => {
          let dot = document.createElement("div");
          dot.style.position = "absolute";
          dot.style.backgroundColor = color;
          dot.style.width = "5px";
          dot.style.height = "5px";
          dot.style.borderRadius = "50%";
          dot.style.top = `${y}px`;
          dot.style.left = `${x}px`;
          dot.style.zIndex = 2;
          return dot;
        };

        if (neckCoordinates) {
          let [leftX, leftY] = neckCoordinates.left_point;
          leftX = leftX * 300;
          leftY = leftY * 350;

          let [rightX, rightY] = neckCoordinates.right_point;
          rightX = rightX * 300;
          rightY = rightY * 350;

          let centerX = (leftX + rightX) / 2;
          let centerY = (leftY + rightY) / 2;

          demoDiv.appendChild(createDot(leftX, leftY, "orange"));
          demoDiv.appendChild(createDot(rightX, rightY, "green"));
          demoDiv.appendChild(createDot(centerX, centerY, "tomato"));
        }

        if (earCoordinates) {
          if (earCoordinates[0]) {
            let [leftEarX, leftEarY] = earCoordinates[0];
            leftEarX = leftEarX * 300;
            leftEarY = leftEarY * 350;

            demoDiv.appendChild(createDot(leftEarX, leftEarY, "black"));
          }

          if (earCoordinates[1]) {
            let [rightEarX, rightEarY] = earCoordinates[1];
            rightEarX = rightEarX * 300;
            rightEarY = rightEarY * 350;

            demoDiv.appendChild(createDot(rightEarX, rightEarY, "black"));
          }
        }
      }
    }
  };

  const handleNewDebugVersion = () => {
    const demoDiv = document.querySelector(".mainDemo");

    if (!demoDiv) {
      console.error("Element with class 'demo' not found in the DOM.");
      return;
    }
    demoDiv.innerHTML = "";

    if (demoDiv.innerHTML) {
      demoDiv.innerHTML = "";
    } else {
      if (
        parseInt(imageDetails.iBodyTypeId) === 1 ||
        imageDetails.iBodyTypeId === 1
      ) {
        const wristCoordinates = newCoordinates.wrist
          ? newCoordinates.wrist
          : newCoordinates;

        if (wristCoordinates) {
          let [leftX, leftY] = wristCoordinates.left;
          leftX = leftX * 400;
          leftY = leftY * 450;

          let [rightX, rightY] = wristCoordinates.right;
          rightX = rightX * 400;
          rightY = rightY * 450;

          let centerX = (leftX + rightX) / 2;
          let centerY = (leftY + rightY) / 2;

          demoDiv.innerHTML = "";

          const createDot = (x, y, color) => {
            let dot = document.createElement("div");
            dot.style.position = "absolute";
            dot.style.backgroundColor = color;
            dot.style.width = "5px";
            dot.style.height = "5px";
            dot.style.top = `${y}px`;
            dot.style.left = `${x}px`;
            dot.style.zIndex = 2;
            dot.style.borderRadius = "50%";
            return dot;
          };

          demoDiv.appendChild(createDot(leftX, leftY, "orange"));
          demoDiv.appendChild(createDot(rightX, rightY, "green"));
          demoDiv.appendChild(createDot(centerX, centerY, "tomato"));
        } else {
          console.log("Finger data not found for the current finger.");
        }
      } else if (parseInt(imageDetails.iBodyTypeId) === 3) {
        const fingerCoordinates = newCoordinates;
        if (fingerCoordinates) {
          ["Index", "Middle", "Pinky", "Ring"].forEach((finger, index) => {
            const currentFingerData =
              fingerCoordinates?.[finger] ||
              fingerCoordinates[finger.toLowerCase()];
            if (currentFingerData) {
              let [leftX, leftY] = currentFingerData.left;
              leftX = leftX * 400;
              leftY = leftY * 450;
              let [rightX, rightY] = currentFingerData.right;
              rightX = rightX * 400;
              rightY = rightY * 450;
              let centerX = (leftX + rightX) / 2;
              let centerY = (leftY + rightY) / 2;
              const demoDiv = document.querySelector(`.mainDemo${index}`);

              demoDiv.innerHTML = "";
              const createDot = (x, y, color) => {
                let dot = document.createElement("div");
                dot.style.position = "absolute";
                dot.style.backgroundColor = color;
                dot.style.width = "5px";
                dot.style.height = "5px";
                dot.style.top = `${y}px`;
                dot.style.left = `${x}px`;
                dot.style.zIndex = 2;
                dot.style.borderRadius = "50%";
                return dot;
              };
              demoDiv.appendChild(createDot(leftX, leftY, "orange"));
              demoDiv.appendChild(createDot(rightX, rightY, "green"));
              demoDiv.appendChild(createDot(centerX, centerY, "tomato"));
            } else {
              console.error("Finger data not found for the current finger.");
            }
          });
        }
      } else if (parseInt(imageDetails.iBodyTypeId) === 2) {
        // const neckCoordinates = newCoordinates.neck_coordinates.neck_wide;

        const earCoordinates = newCoordinates?.ear_coordinates;

        demoDiv.innerHTML = "";

        const createDot = (x, y, color) => {
          let dot = document.createElement("div");
          dot.style.position = "absolute";
          dot.style.backgroundColor = color;
          dot.style.width = "5px";
          dot.style.height = "5px";
          dot.style.borderRadius = "50%";
          dot.style.top = `${y}px`;
          dot.style.left = `${x}px`;
          dot.style.zIndex = 2;
          return dot;
        };

        // if (neckCoordinates) {
        //   let [leftX, leftY] = neckCoordinates.left_point;
        //   leftX = leftX * 400;
        //   leftY = leftY * 450;

        //   let [rightX, rightY] = neckCoordinates.right_point;
        //   rightX = rightX * 400;
        //   rightY = rightY * 450;

        //   let centerX = (leftX + rightX) / 2;
        //   let centerY = (leftY + rightY) / 2;

        //   demoDiv.appendChild(createDot(leftX, leftY, "orange"));
        //   demoDiv.appendChild(createDot(rightX, rightY, "green"));
        //   demoDiv.appendChild(createDot(centerX, centerY, "tomato"));
        // }

        if (earCoordinates) {
          if (earCoordinates[0]) {
            let [leftEarX, leftEarY] = earCoordinates[0];
            leftEarX = leftEarX * 400;
            leftEarY = leftEarY * 450;

            demoDiv.appendChild(createDot(leftEarX, leftEarY, "black"));
          }

          if (earCoordinates[1]) {
            let [rightEarX, rightEarY] = earCoordinates[1];
            rightEarX = rightEarX * 400;
            rightEarY = rightEarY * 450;

            demoDiv.appendChild(createDot(rightEarX, rightEarY, "black"));
          }
        }
      } else if (parseInt(imageDetails.iBodyTypeId) === 4) {
        const neckCoordinates = newCoordinates?.neck_coordinates?.neck_wide
          ? newCoordinates?.neck_coordinates?.neck_wide
          : newCoordinates?.neck_mask_wide;

        const earCoordinates = newCoordinates?.ear_coordinates;

        demoDiv.innerHTML = "";

        const createDot = (x, y, color) => {
          let dot = document.createElement("div");
          dot.style.position = "absolute";
          dot.style.backgroundColor = color;
          dot.style.width = "5px";
          dot.style.height = "5px";
          dot.style.borderRadius = "50%";
          dot.style.top = `${y}px`;
          dot.style.left = `${x}px`;
          dot.style.zIndex = 2;
          return dot;
        };

        if (neckCoordinates) {
          let [leftX, leftY] = neckCoordinates.left_point;
          leftX = leftX * 400;
          leftY = leftY * 450;

          let [rightX, rightY] = neckCoordinates.right_point;
          rightX = rightX * 400;
          rightY = rightY * 450;

          let centerX = (leftX + rightX) / 2;
          let centerY = (leftY + rightY) / 2;

          demoDiv.appendChild(createDot(leftX, leftY, "orange"));
          demoDiv.appendChild(createDot(rightX, rightY, "green"));
          demoDiv.appendChild(createDot(centerX, centerY, "tomato"));
        }

        if (earCoordinates) {
          if (earCoordinates[0]) {
            let [leftEarX, leftEarY] = earCoordinates[0];
            leftEarX = leftEarX * 400;
            leftEarY = leftEarY * 450;

            demoDiv.appendChild(createDot(leftEarX, leftEarY, "black"));
          }

          if (earCoordinates[1]) {
            let [rightEarX, rightEarY] = earCoordinates[1];
            rightEarX = rightEarX * 400;
            rightEarY = rightEarY * 450;

            demoDiv.appendChild(createDot(rightEarX, rightEarY, "black"));
          }
        }
      }
    }
  };

  useEffect(() => {
    if (imageDetails.sURL) {
      handleDebugVersion();
    }
  }, [imageDetails.sURL, imageDetails.sCoordinate]);

  useEffect(() => {
    if (newCoordinates) {
      handleNewDebugVersion();
    }
  }, [newCoordinates]);

  const handleInputChange = (key, subKey, index, value) => {
    // const value = e.target.value;
    // if (/^\d*$/.test(value)) {
    //   setInputMessage("");
    // } else {
    //   setInputMessage("Please enter numbers only.");
    // }
    // setSearchInput(value);

    setNewCoordinates((prev) => {
      const updated = { ...prev };

      if (/^\d*\.?\d*$/.test(value)) {
        if (index !== undefined) {
          updated[key][subKey][index] = value;
        } else if (imageDetails.iBodyTypeId === 1) {
          updated["wrist"][key][subKey] = value;
        } else {
          updated[key][subKey] = value;
        }
      }

      return updated;
    });
  };

  const handleChangeCoordinate = () => {
    const updatedGalleries = imageTabs.map((gallery) =>
      gallery.iGalleryId === selectedModalId
        ? { ...gallery, sCoordinates: newCoordinates }
        : gallery
    );
    setImageTabs(updatedGalleries);
  };

  const handleNeckInputChange = (key, subKey, field, index, value) => {
    setNewCoordinates((prevCoordinates) => {
      const updatedCoordinates = { ...prevCoordinates };
      if (/^\d*\.?\d*$/.test(value)) {
        if (index !== undefined) {
          updatedCoordinates[key][subKey][field][index] = value;
        } else {
          updatedCoordinates[key][subKey][field] = value;
        }
      }

      return updatedCoordinates;
    });
  };

  const getPythonCoordaintes = async (points) => {
    try {
      let url;

      switch (selectedImage.iBodyTypeId) {
        case 3:
          points = Object.entries(points).reduce((acc, [finger, coords]) => {
            acc[finger] = {};

            Object.entries(coords).forEach(([key, value]) => {
              if (Array.isArray(value)) {
                acc[finger][key] = [value]; // wrap coordinate pair
              } else {
                acc[finger][key] = value; // keep rotation as is
              }
            });

            return acc;
          }, {});
          url = endpoint.GET_FINGER_COORD;
          break;
        case 4:
          url = endpoint.GET_NECK_COORD;
          break;
        case 1:
          points = Object.entries(points.Wrist)
            .filter(([_, value]) => Array.isArray(value) && value.length === 2)
            .reduce((acc, [key, value]) => {
              acc[key] = [parseFloat(value[0]), parseFloat(value[1])];
              return acc;
            }, {});
          url = endpoint.GET_WRIST_COORD;
          break;
        case 2:
          url = endpoint.GET_EAR_COORD;
          break;
        default:
          console.warn("Unsupported body type ID:", selectedImage.iBodyTypeId);
          return;
      }

      const response = await apiHandler({
        url: `${process.env.REACT_APP_PYTHON_URL}${url}`,
        method: "POST",
        data: {
          sCoordinate: points,
          sImageURL: selectedImage.sURL,
        },
      });
      console.log(response);

      if ((response.status = 200)) {
        console.log("Python coordinates:", response.data.results);
        setIsPythonCalled(!isPythonCalled);
        return response.data.results;
      }
      return null;
    } catch (error) {
      console.error("Error getting python coordinates:", error);
    }
  };

  const savePythonCoord = (newCoordinates) => {
    console.log("called", newCoordinates);
    const updatedImageTabs = imageTabs.map((img) => {
      if (img.iGalleryId === selectedImage.iGalleryId) {
        return {
          ...img,
          sCoordinates: JSON.stringify(newCoordinates),
        };
      }
      return img;
    });
    setIsPythonCalled(false);
    setOpenImageMarking(false);
    setImageTabs(updatedImageTabs);
  };
  console.log(imageTabs);

  return {
    modelDetails,
    handleChange,
    handleAddImageTab,
    handleTabLabelChange,
    handleImageChange,
    imageJson,
    imageTabs,
    handleDelete,
    selectOptions,
    show,
    handleClose,
    createitemstatus,
    navigating,
    handleModelChange,
    apiLoader,
    handleBack,
    openImage,
    setOpenImage,
    imageError,
    handleEdit,
    isImageEditing,
    setIsImageEditing,
    isEditing,
    imageSrc,
    handleSubmit,
    imageLoader,
    errorMessage,
    confirmDelete,
    setConfirmDelete,
    deleteIndex,
    setDeleteIndex,
    handleBlur,
    renderErrorMessage,
    setImageJson,
    imageDetails,
    setImageDetails,
    newCoordinates,
    setNewCoordinates,
    openCoordinates,
    setOpenCoordinates,
    selectedModalId,
    setSelectedModalId,
    coordinatesRef,
    handleEditClick,
    isEdit,
    setIsEdit,
    handleInputChange,
    handleChangeCoordinate,
    handleNeckInputChange,
    openImageMarking,
    setOpenImageMarking,
    selectedImage,
    setSelectedImage,
    isPythonCalled,
    getPythonCoordaintes,
    savePythonCoord,
  };
};

export default useCreateModel;
